import React, {useState} from 'react';
import {Link} from 'gatsby';
import GeneralSearchForm from '../Form/GeneralSearchForm';
import {StringParam, useQueryParam} from 'use-query-params';
import axios from 'axios';
import {isEmpty, isEqual} from 'lodash';

interface SearchResult {
  n_id: number;
  n_path: string;
  n_title: string;
  n_type: string;
  n_description: string;
  n_breadcrumbs: string;
}

export default function SearchParagraph(): React.JSX.Element {
  const [searchTerm, setSearchTerm] = useQueryParam('q', StringParam);
  const [searchResults, setSearchResults] = useState([]);

  const searchParam = isEmpty(searchTerm) ? 'all' : searchTerm;
  const searchPath = `${process.env.DRUPAL_SOURCE}api/search?q=${searchParam}`;

  axios.interceptors.request.use((config) => {
    document.querySelector('.loader-overlay')?.classList.remove('hidden');
    return config;
  });

  axios.interceptors.response.use((response) => {
    document.querySelector('.loader-overlay')?.classList.add('hidden');
    return response;
  });

  axios.get(searchPath)
    .then((response) => {
      if (Array.isArray(response.data) && !isEqual(response.data, searchResults)) {
        setSearchResults(response.data);
      }
    });

  return (
    <section className="vl-region">
      <div className="vl-layout">
        <div className="vl-grid vl-grid--is-stacked">
          <div className="vl-col--12-12">
            <div className="vl-u-bg-alt" style={{padding: '2.4rem'}}>
              <GeneralSearchForm/>
            </div>
            <p className="vl-u-text--bold vl-u-spacer-top--small">
              {searchResults.length} {searchResults.length === 1 ? 'resultaat' : 'resultaten'} gevonden
            </p>
          </div>
          <div className="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s">
            <ul className="vl-search-results">
              {searchResults.map((result: SearchResult, idx) => {
                const breadcrumbs = ['Start'];
                result.n_breadcrumbs.split('/').filter((part: string) => part !== '').reverse()
                  .forEach((part: string) => {breadcrumbs.push(part)});
                breadcrumbs.push(result.n_title);

                return (
                  <li key={idx}>
                    <section className="vl-search-result">
                      <ol className="vl-breadcrumb__list">
                        {breadcrumbs.map((part: string, index) => (
                          <li key={index} className="vl-breadcrumb__list__item">
                            <span className="vl-breadcrumb__list__item__separator"/>
                            {part}
                          </li>
                        ))}
                      </ol>
                      <h3 className="vl-search-result__title vl-u-spacer-bottom--xsmall">
                        <Link
                          to={result.n_path}
                          className="vl-search-result__title__link vl-title--h3"
                          style={{marginRight: '1rem'}}
                          dangerouslySetInnerHTML={{__html: result.n_title}}
                        />
                        <span className="pill">
                          {result.n_type}
                        </span>
                      </h3>
                      {result.n_description ? (
                        <div className="vl-search-result__content-group line-clamp-2">
                          <p dangerouslySetInnerHTML={{__html: result.n_description}}/>
                        </div>
                      ) : null}
                    </section>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
